/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentCaseCloser/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
let Configuration = React.lazy(() => import('./Configuration/index'))



/** @type {import('Simple/types.js').View} */
export default function TreatmentCaseCloser({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentCaseCloser"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="TreatmentCaseCloser.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-XHTiD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TreatmentCaseCloser.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-XHTiD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-XHTiD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--g-4-XHTiD': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Case closer"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Setup your case closer process - steps, payment plans, and discounts."
/>
</div>
<div
  data-testid="TreatmentCaseCloser.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-5-XHTiD': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="TreatmentCaseCloser.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-2-XHTiD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-XHTiD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal}`}
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Feature Access"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Configuration/FeatureAccess'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Configuration/FeatureAccess'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Flow Steps"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Configuration/Steps'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Configuration/Steps'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Payment Frequencies"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Configuration/Frequencies'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Configuration/Frequencies'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Autodraft"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Configuration/Autodraft'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Configuration/Autodraft'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Down Payment"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Configuration/DownPayment'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Configuration/DownPayment'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Custom Plan Ruleset"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Configuration/CustomPlanRulesets'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Configuration/CustomPlanRulesets'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Default Payment Plans"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Configuration/DefaultPaymentPlans'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Configuration/DefaultPaymentPlans'))}
/>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<SubMenuTab
{...childProps}
  viewPath={`${viewPath}/SubMenuTab`}
 text="Payment Methods"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Configuration/PaymentMethods'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Configuration/PaymentMethods'))}
/>
)}
</SupportOnly>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Discount Settings"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Configuration/DiscountSettings'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Configuration/DiscountSettings'))}
/>
</div>
<div
  data-testid="TreatmentCaseCloser.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-XHTiD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-XHTiD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-1-XHTiD': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical3}`}
>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<Configuration
{...childProps}
  viewPath={`${viewPath}/Configuration`}
/>
)}
</SuspenseBoundary>
</div>
</div>
</div>
{children}
</React.Fragment>)
}